import React, { useState } from 'react';
import { Layout } from 'antd';
import { Typography, message } from 'antd';
import { Button } from "antd";
import axios from 'axios';
import { BASE_URL } from "../config"
import { LoginModal } from "./LoginModal"

const styles = {
    header: {
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: "20px"
    }
}

const Header = ({ loginStatus, setLoginStatus }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    async function logout() {
        //call logout
        const key = 'updatable';
        messageApi
            .open({
                type: 'loading',
                content: 'Logout in progress..',
                duration: 0,
                key: key
            })
        const loginres = await axios.post(BASE_URL + '/api/coins.php', { type: "logout" }, { withCredentials: true });
        if (loginres.data.status) {
            messageApi.open({ type: "success", content: "Logout Successful", duration: 2.5, key: key });
            setLoginStatus(false);
        } else {
            messageApi.open({ type: "error", content: "Logout Failed", duration: 3, key: key });
        }


    }
    function openModal() {
        setModalOpen(true);
    }
    return <>
        {contextHolder}
        <Layout.Header style={styles.header}>
            <Typography.Title level={4} style={{ margin: 0 }}>Crypto Dashboard</Typography.Title>
            <Button onClick={() => { (loginStatus) ? logout() : openModal() }}>{(loginStatus) ? "Logout" : "Login"}</Button>
        </Layout.Header>
        <LoginModal modalOpen={modalOpen} setModalOpen={setModalOpen} setLoginStatus={setLoginStatus} />
    </>;
};

export default Header;